__webpack_require__.p = "/midnight_ping_ball/";